import { object, string } from 'yup';

export const editTaskNameSchema = object({
  name: string().required('Name is a required field'),
  description: string().notRequired().nullable(),
});
